<template>
<div>

    <section class="container-section border-bottom">

        <div class="container pt-5 pt-sm-55 pt-md-65 pt-lg-7 pt-xl-75 pt-xxl-7 px-lg-5 px-xl-45 px-xxl-3 mb-6 mb-sm-65 mb-md-7 mb-lg-75 mb-xl-10">
            <div class="row">
                <div class="col-12 col-xl-8 pr-4">
                    <h1 class="h3 text-uppercase text-center text-xl-left mb-0">
                        {{$root.translateString('complete_order')}}
                    </h1>

                    <!-- personal info -->

                    <div class="mt-5" v-if="!isLogged">

                        <span class="h4 d-inline-block mt-2 mb-4 w-100 text-primary">01. {{$root.translateString('personal_details')}}</span>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.new_user.name.state = null" v-model="new_user.name"/>
                                    <label class="placeholder"> {{$root.translateString('name')}}</label>
                                    <div class="pristine-error" :class="validation.new_user.name.state == false ? 'invalid' : 'd-none'">{{validation.new_user.name.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.new_user.email.state = null" v-model="new_user.email"/>
                                    <label class="placeholder"> Email</label>
                                    <div class="pristine-error" :class="validation.new_user.email.state == false ? 'invalid' : 'd-none'">{{validation.new_user.email.message}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-sm-auto align-items-center">
                                <div class="form-wrapper flex-grow-1 ml-0 checkbox text-left">
                                    <input required id="privacy" type="checkbox" name="privacy" v-model="new_user.privacy"/>
                                    <span class="mb-0">
                                        <label for="privacy" class="text-grey mb-1">
                                            {{$root.translateString('acceptance')}} <a class="text-grey text-underline" :href="'/' + lang + '/privacy-policy'" target="_blank">{{$root.translateString('acceptance_link')}}</a>
                                        </label>
                                    </span>
                                    <div class="pristine-error" :class="validation.new_user.privacy.state == false ? 'invalid' : 'd-none'">{{validation.new_user.privacy.message}}</div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-auto align-items-center">
                                <div class="form-wrapper flex-grow-1 ml-0 checkbox text-left">
                                    <input required id="marketing" type="checkbox" name="marketing" v-model="marketing"/>
                                    <span class="mb-0">
                                        <label for="marketing" class="text-grey" style="line-height:1.2">
                                            {{$root.translateString('marketing')}}
                                        </label>
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- shipping -->

                    <div class="mt-5">
                        <span class="h4 d-inline-block mt-2 mb-4 w-100 text-primary">02. {{$root.translateString('shipping_details')}}</span>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.name.state = null" v-model="address.name"/>
                                    <label class="placeholder"> {{$root.translateString('name')}}</label>
                                    <div class="pristine-error" :class="validation.address.name.state == false ? 'invalid' : 'd-none'">{{validation.address.name.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.email.state = null" v-model="address.email"/>
                                    <label class="placeholder"> Email</label>
                                    <div class="pristine-error" :class="validation.address.email.state == false ? 'invalid' : 'd-none'">{{validation.address.email.message}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.phone.state = null" v-model="address.phone"/>
                                    <label class="placeholder"> {{$root.translateString('phone')}}</label>
                                    <div class="pristine-error" :class="validation.address.phone.state == false ? 'invalid' : 'd-none'">{{validation.address.phone.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <input readonly type="text" required autocomplete="off" placeholder=" " value="" class="form-control" :value="lang == 'en' ? 'Italy' : 'Italia'"/>
                                    <label class="placeholder"> {{$root.translateString('country')}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.address.state = null" v-model="address.address"/>
                                    <label class="placeholder"> {{$root.translateString('address')}}</label>
                                    <div class="pristine-error" :class="validation.address.address.state == false ? 'invalid' : 'd-none'">{{validation.address.address.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.city.state = null" v-model="address.city"/>
                                    <label class="placeholder"> {{$root.translateString('city')}}</label>
                                    <div class="pristine-error" :class="validation.address.city.state == false ? 'invalid' : 'd-none'">{{validation.address.city.message}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <v-select
                                        @input="validation.address.province.state = null"
                                        v-model="address.province"
                                        :class="{'full' : (address.province != null && address.province != '')}"
                                        :options="provinces"
                                        label="value"
                                        index="label"
                                        :reduce="label => label.label"
                                    >
                                        <template v-slot:no-options="{ search, searching }">
                                            <template v-if="searching">
                                                <small class="not-found">{{$root.translateString('no_results')}} <strong>{{ search }}</strong></small>
                                            </template>
                                        </template>
                                    </v-select>
                                    <label class="placeholder"> {{$root.translateString('province')}}</label>
                                    <div class="pristine-error" :class="validation.address.province.state == false ? 'invalid' : 'd-none'">{{validation.address.province.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.cap.state = null" v-model="address.cap"/>
                                    <label class="placeholder"> {{$root.translateString('cap')}}</label>
                                    <div class="pristine-error" :class="validation.address.cap.state == false ? 'invalid' : 'd-none'">{{validation.address.cap.message}}</div>
                                </div>
                            </div>
                        </div>

                    </div>


                    <!-- billing -->

                    <div class="w-100 mt-45" v-if="user.billing.require_invoice">
                        <span class="h4 d-inline-block mt-2 mb-4 w-100 text-primary">03. {{$root.translateString('invoice_details')}}</span>

                        <div class="col-12 mt-3 mb-4">
                            <div class="row">
                                <div class="col-auto align-items-center pl-0 mr-3">
                                    <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio text-left">
                                        <input required id="private" type="radio" name="billing-type" value="private" v-model="billing.type"/>
                                        <span class="mb-0">
                                            <label for="private" class="text-grey">
                                                {{$root.translateString('private')}}
                                            </label>
                                        </span>
                                        <span class="mt-1 is-invalid"></span>
                                    </div>
                                </div>
                                <div class="col-auto align-items-center mr-3">
                                    <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio text-left">
                                        <input required id="company" type="radio" name="billing-type" value="company" v-model="billing.type"/>
                                        <span class="mb-0">
                                        <label for="company" class="text-grey">
                                            {{$root.translateString('company')}}
                                        </label>
                                    </span>
                                        <span class="mt-1 is-invalid"></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="billing.type == 'company'">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                        <input class="form-control" placeholder=" " type="text" v-model="billing.name" @focus="validation.billing.name.state = null">
                                        <label class="placeholder"> {{$root.translateString('company_name')}} </label>
                                        <div class="pristine-error" :class="validation.billing.name.state == false ? 'invalid' : 'd-none'">{{validation.billing.name.message}}</div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                        <input class="form-control" placeholder=" " type="text" v-model="billing.fiscal_code" @focus="validation.billing.fiscal_code.state = null">
                                        <label class="placeholder"> {{$root.translateString('vat')}} </label>
                                        <div class="pristine-error" :class="validation.billing.fiscal_code.state == false ? 'invalid' : 'd-none'">{{validation.billing.fiscal_code.message}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="">

                            <div class="" v-if="billing.type == 'company'">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="email" v-model="billing.pec" @focus="validation.billing.pec.state = null">
                                            <label class="placeholder"> {{$root.translateString('pec')}} </label>
                                            <div class="pristine-error" :class="validation.billing.pec.state == false ? 'invalid' : 'd-none'">{{validation.billing.pec.message}}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="text" v-model="billing.sdi" @focus="validation.billing.sdi.state = null">
                                            <label class="placeholder"> {{$root.translateString('sdi')}} </label>
                                            <div class="pristine-error" :class="validation.billing.sdi.state == false ? 'invalid' : 'd-none'">{{validation.billing.sdi.message}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="" v-if="billing.type == 'company'">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="email" v-model="billing.address" @focus="validation.billing.address.state = null">
                                            <label class="placeholder"> {{$root.translateString('address')}} </label>
                                            <div class="pristine-error" :class="validation.billing.address.state == false ? 'invalid' : 'd-none'">{{validation.billing.address.message}}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="text" v-model="billing.city" @focus="validation.billing.city.state = null">
                                            <label class="placeholder"> {{$root.translateString('city')}} </label>
                                            <div class="pristine-error" :class="validation.billing.city.state == false ? 'invalid' : 'd-none'">{{validation.billing.city.message}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="" v-if="billing.type == 'company'">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                            <v-select
                                                @input="validation.billing.province.state = null"
                                                v-model="billing.province"
                                                :class="{'full' : (billing.province != null && billing.province != '')}"
                                                :options="provinces"
                                                label="value"
                                                index="label"
                                                :reduce="label => label.label"
                                            >
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        <small class="not-found">{{$root.translateString('no_results')}} <strong>{{ search }}</strong></small>
                                                    </template>
                                                </template>
                                            </v-select>
                                            <label class="placeholder"> {{$root.translateString('province')}} </label>
                                            <div class="pristine-error" :class="validation.address.province.state == false ? 'invalid' : 'd-none'">{{validation.address.province.message}}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="number" v-model="billing.cap" @focus="validation.billing.cap.state = null">
                                            <label class="placeholder">  {{$root.translateString('cap')}} </label>
                                            <div class="pristine-error" :class="validation.billing.cap.state == false ? 'invalid' : 'd-none'">{{validation.billing.cap.message}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="billing.type != 'company'">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-wrapper mb-3 mb-lg-35 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="text" v-model="billing.fiscal_code" @focus="validation.billing.fiscal_code.state = null">
                                            <label class="placeholder">  {{$root.translateString('fiscal_code')}} </label>
                                            <div class="pristine-error" :class="validation.billing.fiscal_code.state == false ? 'invalid' : 'd-none'">{{validation.billing.fiscal_code.message}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- payment -->

                    <div class="w-100 mt-5 pb-2">

                        <span class="h4 d-inline-block mt-2 mb-5 w-100 text-primary">
                            <span v-text="user.billing.require_invoice == false ? '03. ' : '04. '"></span> {{$root.translateString('payment_methods')}}
                        </span>

                        <div class="col-12">
                            <div class="row">
                                <div class="col-12 align-items-center d-flex px-0 align-items-start border-top ">
                                    <div class="d-flex flex-grow-1 w-100 py-4">
                                        <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio checkbox--radio--bigger  text-left">
                                            <input required id="payment1" type="radio" name="payment_method" value="stripe" v-model="pay.method"/>
                                            <span class="mb-0">
                                                <label for="payment1" class="text-dark d-flex flex-column mb-0">
                                                    <span class="h6 h5-sm text-uppercase mb-1">{{$root.translateString('credit_card')}}</span>
                                                    <span class="h6 text-grey mb-0 pr-4" v-if="pay.method == 'stripe'">{{$root.translateString('credit_card_p')}}</span>
                                                    <img class="mt-2 d-sm-none" v-if="pay.method != 'stripe'" src="/images/payment_methods/stripe.svg" alt="Carta di credito" height="30" width="150"/>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-none d-sm-block">
                                        <img src="/images/payment_methods/stripe.svg" alt="Carta di credito" height="30" width="150"/>
                                    </div>
                                </div>
                                <div class="col-12 align-items-center d-flex px-0 align-items-start border-top ">
                                    <div class="d-flex flex-grow-1 w-100 py-4">
                                        <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio checkbox--radio--bigger  text-left">
                                            <input required id="payment2" type="radio" name="payment_method" value="paypal" v-model="pay.method"/>
                                            <span class="mb-0">
                                                <label for="payment2" class="text-dark d-flex flex-column mb-0">
                                                    <span class="h6 h5-sm text-uppercase mb-1">PayPal</span>
                                                    <span class="h6 text-grey mb-0 pr-4" v-if="pay.method == 'paypal'">{{$root.translateString('paypal_p')}}</span>
                                                    <img class="mt-2 d-sm-none" v-if="pay.method != 'paypal'" src="/images/payment_methods/paypal.svg" alt="PayPal" height="30" width="48"/>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-none d-sm-block">
                                        <img src="/images/payment_methods/paypal.svg" alt="PayPal" height="30" width="48"/>
                                    </div>
                                </div>

                                <div class="col-12 align-items-center d-flex px-0 align-items-start border-bottom"></div>

                            </div>
                        </div>

                    </div>

                    <!-- message -->

                    <div class="mt-5">
                        <span class="h4 d-inline-block mt-2 mb-4 w-100 text-primary">
                            <span v-text="user.billing.require_invoice == false ? '04. ' : '05. '"></span> {{$root.translateString('ask_for_gift_short')}}
                        </span>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-wrapper mb-3">
                                    <textarea required name="message" autocomplete="off" placeholder=" " v-model="giftPack.message" class="form-control pt-2" style="height: 50px;" cols="60"></textarea>
                                    <label class="placeholder">{{$root.translateString('ask_for_gift')}}</label>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div class="col-12 col-lg-8 offset-lg-2 offset-xl-0 col-xl-4 mt-5 mt-sm-55 mt-md-6 mt-lg-6 mt-xl-0">
                    <div class="side-panel">
                        <div class="border">
                            <div class="w-100 pt-3 px-4 border-bottom">
                                <div class="d-flex flex-column pt-1">

                                    <div class="w-100 d-flex product-line mb-3" v-for="(item, key) in cart" :key="key">
                                        <img width="33" height="42" class="ml-n2 mt-1" :src="item.options.image" :alt="item.options.name" />
                                        <div class="d-flex flex-column flex-grow-1 pl-2">
                                            <div class="d-flex flex-grow-1 pl-0 pt-0 w-100 ml-n2">
                                                <span class="pr-2 h-100 text-nowrap"></span>
                                                <span class="flex-grow-1 d-flex flex-column">
                                                    <span class="text-uppercase">{{item.qty}} <small>x</small> {{item.options.name}}</span>
                                                    <template v-if="lang == 'it'">
                                                        <span class="w-100 text-grey" v-if="item.options.type == 'vini'" v-text="item.options.combination"></span>
                                                        <span class="w-100 text-grey" v-else>Pravis</span>
                                                    </template>
                                                    <template v-else>
                                                        <span class="w-100 text-grey" v-if="item.options.type == 'vini'" v-text="item.options.combination.toLowerCase().replace('bottiglia', 'Bottle')"></span>
                                                        <span class="w-100 text-grey" v-else>Pravis</span>
                                                    </template>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="py-0 d-flex mt-0 pl-0">
                                            <span class="flex-grow-1 price text-nowrap">
                                                € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="totals px-4">
                                <div class="line d-flex h6 mt-4 mb-2 text-grey">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('subtotal')}}
                                    </span>
                                    <span>
                                        € {{ $root.currencyDisplaySimple(priceTotalWt) }}
                                    </span>
                                </div>
                                <div class="line d-flex h6 mb-2 text-grey">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('shipping')}}
                                    </span>
                                    <span>
                                        <span v-if="shipping > 0">
                                         € {{ $root.currencyDisplaySimple(shipping) }}
                                        </span>
                                        <span v-else>{{$root.translateString('free')}}</span>
                                    </span>
                                </div>
                                <div class="line d-flex h6 mb-2 text-grey" v-if="discount > 0">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('discount')}}
                                    </span>
                                    <span>
                                        € {{ $root.currencyDisplaySimple(discount) }}
                                    </span>
                                </div>
                                <div class="line d-flex text-grey py-35 mb-2">
                                    <span class="flex-grow-1">
                                        <span class="h4 text-dark">{{$root.translateString('total')}}</span>
                                        &nbsp;
                                        <span class="h6">
                                            <small>({{$root.translateString('tax_included')}})</small>
                                        </span>
                                    </span>
                                    <span>
                                        <span class="h4 text-dark">€ {{ $root.currencyDisplaySimple(finalPrice) }}</span>
                                    </span>
                                </div>
                                <div v-if="paymentFailed" class="mb-35 p-3" style="border: 1px solid #f00">
                                  <span style="color: #f00">{{$root.translateString('payment_failed_message')}}</span>
                                </div>
                                <div class="line d-flex mb-35 text-grey">
                                    <button type="button" class="btn btn-primary w-100 text-uppercase" @click="createOrder" href="javascript:void(0)" :class="{'loading' : loading}" :disabled="btn_disabled">
                                        <span>{{$root.translateString('complete_order')}}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <discount-box :lang="lang" :discount="discount"></discount-box>

                    </div>
                </div>
            </div>

        </div>

    </section>

</div>
</template>
<script>
export default {
    props: ['lang', 'provinces', 'isLogged', 'userProp', 'freeShippingAt'],
    data() {
        return {
            user: {
                addresses: [],
                billing: {
                    require_invoice: true,
                    data: {
                        type: 'private',
                        name: '',
                        fiscal_code: '',
                        sdi: '',
                        pec: '',
                        address: '',
                        city: '',
                        cap: '',
                        province: '',
                    }
                },
            },
            hide_save_billing_info: true,
            save_billing_info: false,
            save_new_address: false,
            hide_save_address: true,
            new_user: {
                name: '',
                email: '',
                password: '',
                confirm_password: '',
                create_account: false,
            },
            hasGift: false,
            stripeObject: null,
            paymentRequest: null,
            loading: false,
            paymentFailed: false,
            pay: {
                method: 'stripe'
            },
            discount_placeholder: true,
            giftPack: {
                status: true,
                message: '',
            },
            address: {
                name: '',
                address: '',
                email: '',
                city: '',
                cap: '',
                province: '',
                country: 'IT',
            },
            billing: {
                type: 'private',
                name: '',
                fiscal_code: '',
                sdi: '',
                pec: '',
                address: '',
                city: '',
                cap: '',
                province: '',
            },
            discountCode: '',
            cartRaw: null,
            priceTotalWt: 0,
            finalPrice: 0,
            shipping: 0,
            discount: 0,
            count: 0,
            showDiscountBox: false,
            missing_for_free_shipping: 0,
            validation: {
                new_user: {
                    name: {
                        state: null,
                        message: '',
                    },
                    email: {
                        state: null,
                        message: '',
                    },
                    phone: {
                        state: null,
                        message: '',
                    },
                    password: {
                        state: null,
                        message: '',
                    },
                    password_confirmation: {
                        state: null,
                        message: '',
                    },
                    privacy: {
                        state: null,
                        message: '',
                    },
                },
                address: {
                    name: {
                        state: null,
                        message: '',
                    },
                    phone: {
                        state: null,
                        message: '',
                    },
                    address: {
                        state: null,
                        message: '',
                    },
                    email: {
                        state: null,
                        message: '',
                    },
                    city: {
                        state: null,
                        message: '',
                    },
                    cap: {
                        state: null,
                        message: '',
                    },
                    province: {
                        state: null,
                        message: '',
                    },
                    privacy: {
                        state: null,
                        message: '',
                    },
                },
                billing: {
                    name: {
                        state: null,
                        message: '',
                    },
                    fiscal_code: {
                        state: null,
                        message: '',
                    },
                    sdi: {
                        state: null,
                        message: '',
                    },
                    pec: {
                        state: null,
                        message: '',
                    },
                    address: {
                        state: null,
                        message: '',
                    },
                    city: {
                        state: null,
                        message: '',
                    },
                    cap: {
                        state: null,
                        message: '',
                    },
                    province: {
                        state: null,
                        message: '',
                    },
                },
                discount: {
                    state: null,
                    message: ''
                },
            },
            btn_disabled: false,
            profile_loaded: false,
            billing_memo: null
        }
    },
    created() {

        if(typeof this.userProp != 'undefined' && this.isLogged) {
            if(typeof this.userProp.billing !== 'undefined' && this.userProp.billing != null) {
                this.$set(this.user, 'billing', this.userProp.billing);
            };

            this.$set(this.user, 'addresses', this.userProp.addresses);

            let new_address = {
                new: true,
                label: 'Usa nuovo indirizzo',
                name: '',
                address: '',
                city: '',
                cap: '',
                province: '',
                country: 'IT',
            };

            for(let i=0; i< this.user.addresses.length; i++) {
                this.$set(this.user.addresses[i], 'new', false);
                this.$set(this.user.addresses[i], 'label', this.user.addresses[i].address + ' - ' + this.user.addresses[i].cap + ' - ' + this.user.addresses[i].city + ' (' + this.user.addresses[i].province + ')');
            }

            if(this.user.addresses.length == 0) {
                this.hide_save_address = false;
            }

            this.user.addresses.push(new_address);

            this.address = this.user.addresses[0];
            this.billing = this.user.billing.data;

            this.billing_memo = JSON.parse(JSON.stringify(this.billing));

        }

        if(this.isLogged && this.userProp.billing == null) {
            this.hide_save_billing_info = false;
        }

        this.getCart();
    },
    watch: {
        billing: {
            handler: function (n, o) {
                if(this.profile_loaded && this.isLogged && this.userProp.billing != null) {
                    if(JSON.stringify(n) != JSON.stringify(this.billing_memo)) {
                        this.hide_save_billing_info = false;
                    }else{
                        this.hide_save_billing_info = true;
                    }
                }
            },
            deep: true,
        },
        'user.billing.require_invoice' : {
            handler: function (n, o) {
                if(!n && this.isLogged) {
                    this.billing = this.billing_memo;
                }
            },
            deep: true,
        }
    },
    mounted() {

        if($('.side-panel').length) {

            let top = document.querySelector('.side-panel').getBoundingClientRect().top;
            let width = 0;
            let left = $('.side-panel').offset().left;
            let bounds = document.querySelector('.side-panel').getBoundingClientRect();

            function setSideMenu() {

                if ($(window).width() <= 991) {
                    return false;
                }

                if (window.scrollY < top - 21) {
                    $('.side-panel').removeClass('position-fixed');
                    $('.side-panel').css('top', '');
                    $('.side-panel').css('width', '');
                    $('.side-panel').css('left', '');
                } else {
                    $('.side-panel').addClass('position-fixed');

                    let ch = $('.side-panel').height();

                    let fp = $('.container-section > .container > .row').get(0).getBoundingClientRect().top + $('.container-section > .container > .row').height() - 15;

                    if (fp < (ch + 20)) {

                        let ofst = -(ch - fp)

                        $('.side-panel').css('top', ofst);
                    } else {
                        $('.side-panel').css('top', 20);
                    }

                    $('.side-panel').css('width', width);
                    $('.side-panel').css('left', left);
                }

            }

            setTimeout(() => {

                if ($('.side-panel').length && $(window).width() >= 1200) {

                    top = document.querySelector('.side-panel').getBoundingClientRect().top;
                    width = $('.side-panel').outerWidth();

                    if ($('.side-panel').length) {
                        setSideMenu();
                    }

                    window.addEventListener('scroll', function() {

                        if ($('.side-panel').length) {
                            setSideMenu();
                        }
                    });

                    $(window).on('resize', () => {

                        $('html,body').animate({
                            scrollTop: 0,
                        },'fast');
                        $('.side-panel').removeClass('position-fixed');
                        $('.side-panel').css('top', '');
                        $('.side-panel').css('width', '');
                        $('.side-panel').css('left', '');

                        if ($(window).width() >= 1200) {

                            top = document.querySelector('.side-panel').getBoundingClientRect().top;
                            width = $('.side-panel').outerWidth();

                            if ($('.side-panel').length) {
                                setSideMenu();
                            }

                        } else {

                            $('.side-panel').removeClass('position-fixed');
                            $('.side-panel').css('top', '');
                            $('.side-panel').css('width', '');
                            $('.side-panel').css('left', '');

                        }

                    });

                }

            }, 500);

        }

        this.$eventHub.$on('discount.applied', payload => {
            this.getCart();
        });

    },
    methods: {
        manageSaveAddressCheckbox() {
            if(this.address.new) {
                this.hide_save_address = false;
            } else {
                this.hide_save_address = true;
                this.save_new_address = false;
            }
        },
        toggleLogin() {
            this.$eventHub.$emit('login', {});
        },
        loadStripe() {
            axios.get('/api/cart/stripe')
            .then(response => {
                this.stripeObject = Stripe(response.data.pkey);

                var paymentRequest = this.stripeObject.paymentRequest({
                    country: 'IT',
                    currency: 'eur',
                    total: {
                        label: 'Ordine Shop Azienda Agricola Pravis',
                        amount: parseInt(parseFloat(this.finalPrice) * 100),
                    },
                    requestPayerName: true,
                    requestPayerEmail: true,
                });

                paymentRequest.canMakePayment().then(result => {
                    if (result) {
                        this.paymentRequest = paymentRequest;
                    } else {
                        this.paymentRequest = null
                    }
                });
            })
        },
        getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                this.cartRaw = response.data.cart;
                this.count = response.data.count;
                this.priceTotalWt = response.data.priceTotalWt;
                this.finalPrice = response.data.finalPrice;
                this.discount = response.data.discount;
                this.shipping = response.data.shipping;
                this.missing_for_free_shipping = response.data.missingForFreeShipping;
                this.hasGift = response.data.hasGift;
                this.loadStripe();

                if(this.cart.length == 0) {
                    window.location.href = '/carrello';
                }else{

                    let products_gtm = [];

                    Object.keys(this.cart).forEach(key => {
                        let entry = {};
                        entry.id = this.cart[key].id;
                        entry.quantity = this.cart[key].qty;
                        entry.brand = 'Azienda Agricola Pravis';
                        entry.name = this.cart[key].options.name;
                        entry.price = this.cart[key].price;
                        entry.variant = this.cart[key].options.combination.toLowerCase();
                        entry.category = this.cart[key].options.type;
                        products_gtm.push(entry);
                    })

                    gtag('event', 'begin_checkout', {
                        "items": products_gtm,
                        "coupon": ""
                    });

                    let temp_cart = [];
                    let temp_cart_ids = [];

                    Object.keys(this.cart).forEach(key => {
                        let entry = {};
                        entry.id = this.cart[key].name.replace('<br>', ' ');
                        entry.quantity = this.cart[key].qty;
                        temp_cart.push(entry);
                        temp_cart_ids.push(entry.id);
                    })

                    fbq('track', 'InitiateCheckout',
                        {
                            content_category: "checkout",
                            content_ids: temp_cart_ids,
                            contents: temp_cart,
                            currency: 'EUR',
                            num_items: this.cart.length,
                            value: this.finalPrice,
                            content_type: 'product_group'
                        }
                    );

                    this.profile_loaded = true;

                }

            });
        },
        createOrder()
        {
            this.btn_disabled = true;
            if(this.canProceed()){
                this.loading = true;

                if(this.giftPack.message == '') {
                    this.giftPack.status = false;
                }

                axios.post('/api/cart/create-order', {
                    lang: this.lang,
                    pay: this.pay.method,
                    address: this.address,
                    save_new_address: this.save_new_address,
                    save_billing_info: this.save_billing_info,
                    new_user: this.new_user,
                    require_invoice: this.user.billing.require_invoice,
                    billing: this.billing,
                    discountCode: this.discountCode,
                    marketing: this.marketing,
                    giftPack: this.giftPack
                })
                    .then(response => {
                        if(response.data.action == 'stripe_js') {
                            this.stripeObject.redirectToCheckout({
                                sessionId: response.data.payment_intent
                            }).then(function (result) {
                                this.btn_disabled = false;
                            });
                        } else if(response.data.action == 'stripe_apple_pay') {
                            var stripe = this.stripeObject;
                            var clientSecret = response.data.client_secret;
                            var confirm_page = response.data.confirm_page;
                            this.paymentRequest.on('paymentmethod', ev => {
                                stripe.confirmCardPayment(
                                    clientSecret,
                                    {payment_method: ev.paymentMethod.id},
                                    {handleActions: false}
                                ).then(function(confirmResult) {
                                    if (confirmResult.error) {
                                        ev.complete('fail');
                                    } else {
                                        ev.complete('success');
                                        stripe.confirmCardPayment(response.data.client_secret).then(function(result) {
                                            if (result.error) {
                                            } else {
                                                window.location.href = confirm_page;
                                            }
                                        });
                                    }
                                });
                            });
                        } else if(response.data.action == 'redirect') {
                            window.location.href = response.data.next_action;
                        } else if (response.data.action == 'fail') {
                            // FIX #3: gestione esplicita del caso fail per PayPal (e qualsiasi
                            // altro metodo). In precedenza solo Stripe aveva questo handler,
                            // causando uno spinner infinito se PayPal restituiva action:'fail'.
                            this.btn_disabled = false;
                            this.loading = false;
                            this.paymentFailed = true;
                        }
                    }).catch(e => {
                        // FIX: gestione errori robusta — e.response può essere undefined
                        // in caso di network error. Mostriamo il messaggio di errore
                        // all'utente invece di fare un reload cieco.
                        this.btn_disabled = false;
                        this.loading = false;

                        if(e.response && e.response.data && typeof e.response.data.location != 'undefined') {
                            window.location.href = e.response.data.location;
                        } else {
                            console.error(e);
                            this.paymentFailed = true;
                        }
                    })
            }
        },
        isNotEmpty(object) {
            return (_.isEmpty(object) === false);
        },
        canProceed(){

            let is_invalid = false;

            if(!this.isLogged) {

                Object.keys(this.validation.new_user).forEach((elem, key) => {
                    this.validation.new_user[elem].message = '';
                    this.validation.new_user[elem].state = null;
                });

                if (this.new_user.name == '') {
                    if(this.lang == 'it') {
                        this.validation.new_user.name.message = 'Questo campo non può essere vuoto.';
                    }else{
                        this.validation.new_user.name.message = 'This field cannot be empty.';
                    }
                    this.validation.new_user.name.state = false;
                    is_invalid = true;
                }else{
                    this.validation.new_user.name.state = null;
                }

                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let disposable = require('is-disposable-email');
                if (! re.test(this.new_user.email)) {
                    if(this.lang == 'it') {
                        this.validation.new_user.email.message = 'Non sembra un indirizzo email valido.';
                    }else{
                        this.validation.new_user.email.message = 'The email address is invalid.';
                    }
                    this.validation.new_user.email.state = false;
                    is_invalid = true;
                } else {
                    if (disposable(this.new_user.email)) {
                        if(this.lang == 'it') {
                            this.validation.new_user.email.message = 'Tipologia di servizio email non valido.';
                        }else{
                            this.validation.new_user.email.message = 'You email provider is invalid.';
                        }
                        this.validation.new_user.email.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.new_user.email.state = null;
                    }
                }

                if (this.new_user.create_account) {

                    if (this.new_user.password == '') {
                        if(this.lang == 'it') {
                            this.validation.new_user.password.message = 'Questo campo non può essere vuoto.';
                        }else{
                            this.validation.new_user.password.message = 'This field cannot be empty.';
                        }
                        this.validation.new_user.password.state = false;
                        is_invalid = true;
                    }else{
                        this.validation.new_user.password.state = null;
                    }

                    if (this.new_user.password_confirmation != this.new_user.password || this.user.password_confirmation == '') {
                        if(this.lang == 'it') {
                            this.validation.new_user.password_confirmation.message = 'Questo campo deve coincidere con la password.';
                        }else{
                            this.validation.new_user.password_confirmation.message = 'Questo campo non può essere vuoto.';
                        }
                        this.validation.new_user.password_confirmation.state = false;
                        is_invalid = true;
                    }else{
                        this.validation.new_user.password_confirmation.state = null;
                    }

                }

                if(!this.new_user.privacy) {
                    if(this.lang == 'it') {
                        this.validation.new_user.privacy.message = 'È necessario accettare i termini.';
                    }else{
                        this.validation.new_user.privacy.message = 'You need to accept the terms.';
                    }
                    this.validation.new_user.privacy.state = false;
                    is_invalid = true;
                }

            }

            Object.keys(this.validation.address).forEach((elem, key) => {
                this.validation.address[elem].message = '';
                this.validation.address[elem].state = null;
            });

            Object.keys(this.validation.billing).forEach((elem, key) => {
                this.validation.billing[elem].message = '';
                this.validation.billing[elem].state = null;
            });


            $.each(this.address, (key, elem) => {
                if(typeof this.validation.address[key] != 'undefined') {
                    if(elem == '') {

                        if (this.lang == 'it') {
                            this.validation.address[key].message = 'Il campo è obbligatorio';
                        } else {
                            this.validation.address[key].message = 'This field is required';
                        }

                        this.validation.address[key].state = false;
                        is_invalid = true;
                    }
                }
            });


            if(this.user.billing.require_invoice) {

                if(this.billing.type == 'company') {

                    $.each(this.billing, (key, elem) => {
                        if(elem == '' && key != 'sdi' && key != 'pec'){
                            if(this.lang == 'it') {
                                this.validation.billing[key].message = 'Il campo è obbligatorio';
                            }else{
                                this.validation.billing[key].message = 'This field is required';
                            }
                            this.validation.billing[key].state = false;
                            is_invalid = true;
                        }
                    });

                    if(this.billing.sdi == '' && this.billing.pec == '') {
                        if(this.lang == 'it') {
                            this.validation.billing.pec.message = 'Compila PEC o Codice univoco';
                            this.validation.billing.sdi.message = 'Compila PEC o Codice univoco';
                        }else{
                            this.validation.billing.pec.message = 'Either one between PEC or SDI is required';
                            this.validation.billing.sdi.message = 'Either one between PEC or SDI is required';
                        }
                        this.validation.billing.pec.state = false;
                        this.validation.billing.sdi.state = false;

                        is_invalid = true;
                    }

                }else{
                    if(this.billing.fiscal_code == '') {
                        if(this.lang == 'it') {
                            this.validation.billing.fiscal_code.message = 'Il campo è obbligatorio';
                        }else{
                            this.validation.billing.fiscal_code.message = 'This field is required';
                        }
                        this.validation.billing.fiscal_code.state = false;
                        is_invalid = true;
                    }
                }

            }

            if(is_invalid) {

                setTimeout(
                    () => {

                        this.btn_disabled = false;

                        let elements = document.querySelectorAll('.pristine-error.invalid');

                        $('html,body').animate({
                            scrollTop: parseInt(elements[0].getBoundingClientRect().top + window.scrollY) - 100,
                        },'slow');

                    }
                    , 500);

                return false;
            }

            return true;

        }
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }
            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }
            return tmp;
        },
        managePaymentMethodsCardinal() {
            if(!this.isLogged) {
                return this.user.billing.require_invoice == false ? '03. ' : '04. ';
            }else{
                return this.user.billing.require_invoice == false ? '02. ' : '03. ';
            }
        },
    }
}
</script>

<style lang="scss">

    .v-select {

        .vs__dropdown-toggle{
            padding: 0 !important;
            background: none !important;
            border: 0 !important;
        }

        .vs__selected-options{
            padding:0px !important;
        }

        .vs__actions{
            display: none !important;
        }

        .vs__dropdown-menu{
            top: 50px !important;
            border: 0;
            box-shadow: none;
            background: #f7f7f7;

            &::-webkit-scrollbar {
                width: 4px; /* For Chrome, Safari, and Opera */
            }

        }

        .not-found{
            color:#776c5d !important;
            font-size: .9rem !important;
        }

        .vs__dropdown-option{
            padding: 6px 20px;
            color: #757575;
            background: none;

            &:hover{
                color:#000000;
            }

        }

       & ~ label.placeholder{
       }

        &.vs--open, &.full{

             & ~ label.placeholder{
                 top: 0px;
                 text-transform: uppercase;
                 transition: all 0.1s;
                 -moz-transition: all 0.1s;
                 -webkit-transition: all 0.1s;
                 font-size: 78%;
            }

        }

        .vs__selected{
            margin: 0;
            position: absolute;
            left: 0;
            top: 13px;
            color: #000000;
            padding: 0.375rem 0.6rem;
            font-size: 1.15rem;
        }

    }

</style>